import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { AdobeAnalyticsService } from "../services/adobe-analytics.service";

@Injectable({
    providedIn: "root"
})
export class AdobePageLoadDataResolverService implements Resolve<void> {
    constructor(private adobeAnalytics: AdobeAnalyticsService) {}

    public async resolve(route: ActivatedRouteSnapshot): Promise<void> {
        const pageLoadData = route.data["pageLoadData"];
        const url =
            pageLoadData && pageLoadData.url
                ? pageLoadData.url
                : `${window.location.origin}${this.getResolvedUrl(route)}`;
        this.adobeAnalytics.trackPageLoad({ ...pageLoadData, url });
    }

    private getResolvedUrl(route: ActivatedRouteSnapshot): string {
        return route.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join("/")).join("/");
    }
}
